import { projectCatalogCategories, projectListItemTypes } from '@/Models';

export const projectExplorationTagKeys = {
    exploreYouMayLike: 'exploreYouMayLike',
    exploreActive: 'exploreActive',
    exploreEndingSoon: 'exploreEndingSoon',
    crowdfundingTrending: 'crowdfundingTrending',
    crowdfundingNew: 'crowdfundingNew',
    crowdfundingMostFunded: 'crowdfundingMostFunded',
    crowdfundingEndingSoon: 'crowdfundingEndingSoon',
    upcomingComingSoon: 'upcomingComingSoon',
    upcomingNew: 'upcomingNew',
    upcomingMostPopular: 'upcomingMostPopular',
    latePledge: 'latePledge',
    latePledgeNew: 'latePledgeNew',
    latePledgeMostFunded: 'latePledgeMostFunded',
    latePledgeEndingSoon: 'latePledgeEndingSoon',
    mostDiscussedAll: 'mostDiscussedAll',
    mostDiscussedUpcoming: 'mostDiscussedUpcoming',
    mostDiscussedCrowdfunding: 'mostDiscussedCrowdfunding',
    mostDiscussedLatePledge: 'mostDiscussedLatePledge',
    recentlyAddedUpdatesAll: 'recentlyAddedUpdatesAll',
    recentlyAddedUpdatesUpcoming: 'recentlyAddedUpdatesUpcoming',
    recentlyAddedUpdatesCrowdfunding: 'recentlyAddedUpdatesCrowdfunding',
    recentlyAddedUpdatesLatePledge: 'recentlyAddedUpdatesLatePledge',
    highestFundedActive: 'highestFundedActive',
    highestFundedAllTime: 'highestFundedAllTime',
    preorders: 'preorders',

    techAndInnovationForYou: 'techAndInnovationForYou',
    techAndInnovationUpcoming: 'techAndInnovationUpcoming',
    techAndInnovationCrowdfunding: 'techAndInnovationCrowdfunding',
    techAndInnovationLatePledge: 'techAndInnovationLatePledge',
    techAndInnovationEndingSoon: 'techAndInnovationEndingSoon',
    creativeWorksForYou: 'creativeWorksForYou',
    creativeWorksUpcoming: 'creativeWorksUpcoming',
    creativeWorksCrowdfunding: 'creativeWorksCrowdfunding',
    creativeWorksLatePledge: 'creativeWorksLatePledge',
    creativeWorksEndingSoon: 'creativeWorksEndingSoon',
    communityProjectsForYou: 'communityProjectsForYou',
    communityProjectsUpcoming: 'communityProjectsUpcoming',
    communityProjectsCrowdfunding: 'communityProjectsCrowdfunding',
    communityProjectsLatePledge: 'communityProjectsLatePledge',
    communityProjectsEndingSoon: 'communityProjectsEndingSoon',

    gamingCultureBoardAndCard: 'gamingCultureBoardAndCard',
    gamingCultureTTRPG: 'gamingCultureTTRPG',
    gamingCultureVideo: 'gamingCultureVideoGames',
    gamingCultureOther: 'gamingCultureOthers',

    newOnThePlatformUpcoming: 'newOnThePlatformUpcoming',
    newOnThePlatformCrowdfunding: 'newOnThePlatformCrowdfunding',
    newOnThePlatformLatePledge: 'newOnThePlatformLatePledge',
};

export const projectCatalogCategoriesTechAndInnovation = [
    projectCatalogCategories[projectCatalogCategories.audio].name,
    projectCatalogCategories[projectCatalogCategories.cameraGear].name,
    projectCatalogCategories[projectCatalogCategories.education].name,
    projectCatalogCategories[projectCatalogCategories.energyAndGreenTech].name,
    projectCatalogCategories[projectCatalogCategories.fashionAndWearables].name,
    projectCatalogCategories[projectCatalogCategories.foodAndBeverages].name,
    projectCatalogCategories[projectCatalogCategories.healthAndFitness].name,
    projectCatalogCategories[projectCatalogCategories.home].name,
    projectCatalogCategories[projectCatalogCategories.general].name,
    projectCatalogCategories[projectCatalogCategories.phonesAndAccessories].name,
    projectCatalogCategories[projectCatalogCategories.productivity].name,
    projectCatalogCategories[projectCatalogCategories.transportation].name,
    projectCatalogCategories[projectCatalogCategories.travelAndOutdoors].name,
];

export const projectCatalogCategoriesCreativeWorks = [
    projectCatalogCategories[projectCatalogCategories.art].name,
    projectCatalogCategories[projectCatalogCategories.film].name,
    projectCatalogCategories[projectCatalogCategories.music].name,
    projectCatalogCategories[projectCatalogCategories.danceAndTheater].name,
    projectCatalogCategories[projectCatalogCategories.comics].name,
    projectCatalogCategories[projectCatalogCategories.writingAndPublishing].name,
    projectCatalogCategories[projectCatalogCategories.photography].name,
    projectCatalogCategories[projectCatalogCategories.otherCreations].name,
    projectCatalogCategories[projectCatalogCategories.webSeriesAndTVShows].name,
    projectCatalogCategories[projectCatalogCategories.podcastsBlogsAndVlogs].name,
];

export const projectCatalogCategoriesCommunityProjects = [
    projectCatalogCategories[projectCatalogCategories.localBusinesses].name,
    projectCatalogCategories[projectCatalogCategories.humanRights].name,
    projectCatalogCategories[projectCatalogCategories.wellness].name,
    projectCatalogCategories[projectCatalogCategories.environment].name,
    projectCatalogCategories[projectCatalogCategories.otherCommunityProjects].name,
    projectCatalogCategories[projectCatalogCategories.culture].name,
];

export const projectCatalogCategoriesGamingCulture = [
    projectCatalogCategories[projectCatalogCategories.boardAndCardGames].name,
    projectCatalogCategories[projectCatalogCategories.videoGames].name,
    projectCatalogCategories[projectCatalogCategories.ttrpg].name,
    projectCatalogCategories[projectCatalogCategories.accessories].name,
    projectCatalogCategories[projectCatalogCategories.others].name,
];

export const homeProjectListsTagKeys = {
    [projectListItemTypes.storesAndPreorders]: 'storesAndPreorders',
    [projectListItemTypes.upcoming]: 'upcoming',
    [projectListItemTypes.crowdfunding]: 'crowdfunding',
    [projectListItemTypes.latePledge]: 'latePledge',
    [projectListItemTypes.soloMode]: 'soloMode',
    [projectListItemTypes.stretchPay]: 'stretchPay',
    [projectListItemTypes.ttrpg]: 'ttrpg',
};
